import { render, staticRenderFns } from "./change_phone.vue?vue&type=template&id=2b62d2fc&scoped=true"
import script from "./change_phone.vue?vue&type=script&lang=js"
export * from "./change_phone.vue?vue&type=script&lang=js"
import style0 from "./change_phone.vue?vue&type=style&index=0&id=2b62d2fc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b62d2fc",
  null
  
)

export default component.exports